module.exports = __webpack_public_path__ + "static/img/dc_step_active.52bf0f29.png";